import React from "react";
import "./SimpleCheckbox.css";

const SimpleCheckbox = ({ checked, onChange, disabled = false }) => {
  const handleClick = () => {
    if (disabled) return;      // ✅ prevent click
    onChange?.(!checked);      // ✅ safe optional call
  };
  return (
    <div
      className={`custom-checkbox 
        ${checked ? "checked" : ""} 
        ${disabled ? "disabled" : ""}
      `}
      onClick={handleClick}
    >
      {checked && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M15 4.5L6.75 12.75L3 9"
            stroke="#1A73E8"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </div>
  );
};

export default SimpleCheckbox;
